/* unplugin-vue-components disabled */import { render } from "./VoteModel.vue?vue&type=template&id=580d07f3"
import script from "./VoteModel.vue?vue&type=script&lang=js"
export * from "./VoteModel.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__